import React, { useMemo } from 'react';
import { styled, useStyleConfig, vui } from '../core';
import { cs, filterUndefined, isReactText, isString } from '../utils';
import { LinkProvider } from './context';
import LinkIcon from './linkIcon';
import LinkText from './linkText';
export const LinkBase = styled.aBox `
  align-items: center;
  border-radius: none;
  cursor: pointer;
  display: inline-flex;
  line-height: normal;
  outline: none;
  text-decoration: none;
  transition-duration: instant;
  width: fit-content;
`;
/**
 * Displays a link item. Handles different underline scenarios and opening external links in new tab.
 * Exposes some props to the children via context.
 */
export const Link = vui((props, ref) => {
    const { children, className, decoration, hoverDecoration = 'underline', iconLeft, iconRight, isExternal, isUnderlined, size, text, variant, weight, ...rest } = props;
    const styles = useStyleConfig('Link', props);
    const context = useMemo(() => filterUndefined({ size, variant }), [size, variant]);
    const aliasedProps = filterUndefined({
        fontWeight: weight,
        rel: isExternal ? 'noopener' : undefined,
        target: isExternal ? '_blank' : undefined,
        textDecoration: decoration ?? (isUnderlined ? 'underline' : undefined)
    });
    return (React.createElement(LinkProvider, { value: context },
        React.createElement(LinkBase, { className: cs('vui-link', className), focusRing: 2, hoverTextDecoration: hoverDecoration, ref: ref, ...styles.container, ...aliasedProps, ...rest },
            isString(iconLeft) ? React.createElement(LinkIcon, { mr: 1, name: iconLeft }) : iconLeft,
            children ?? (isReactText(text) ? React.createElement(LinkText, { text: text }) : text),
            isString(iconRight) ? React.createElement(LinkIcon, { ml: 1, name: iconRight }) : iconRight)));
});
Link.Icon = LinkIcon;
Link.Text = LinkText;
export default Link;
